import {createSlice} from "@reduxjs/toolkit";

const initialState = {type: null, payload: {server: {message: ''}}}

const messagesSlice = createSlice({
    name: 'messages',
    initialState,
    reducers: {
        resetError: (state, action) => {
            return {...state, payload: {...state.payload, errors: {}}}
        },
        error: (state, action) => {
            const errors = action.payload.errors || {};

            // console.log('errors', errors)
            if (Object.keys(errors).length === 0) {
                return {...state, payload: {...state.payload, errors: {}}}
            }
            return {...state, payload: {...state.payload, errors: {...state.payload?.errors, ...action.payload.errors}}}
        },
        success: (state, action) => {
            return {...action}
        },
        top: (state, action) => {
            return {...state, payload: {...state.payload, server: {...action.payload.server}}}
        }
    }
})


export const {error, success, top, resetError} = messagesSlice.actions

export default messagesSlice.reducer